// import "babel-polyfill";


import "./libs/jcf";
import "./libs/jcf.select";
import "./libs/slick";

import { initJCFSelect } from "./modules/jcf-init";
import {binder, fwa} from "./libs/binder";
import {constants} from "./modules/constants";
import {staticFunctions} from "./modules/static-functions";
import {headerAnimationHandler} from "./modules/header";
import {mainNav} from "./modules/main-nav";
import {langSwitcher} from "./modules/lang-switcher";
import {googleMap} from "./modules/googleMap";
import {loadAction} from "./modules/load-action";
import {printArticle} from "./modules/printArticle";
import {ajaxFilter} from "./modules/ajax-filter";
import {ajaxMap} from "./modules/ajax-map";
import {imagesSlider} from "./modules/imagesSlider";
import {digitsSlider} from "./modules/digitsSlider";
import {featuredPropertiesSlider} from "./modules/featuredPropertiesSlider";
import {homeMap} from "./modules/homeMap";
import {anchorCareers} from "./modules/anchorCareers";
import {removeMargin} from "./modules/removeMargin";
import {deferredScript} from "./modules/deferred-script";
import {cookiePopup} from "./modules/cookiePopup";


binder({
    bounds: {
        "html": [constants, staticFunctions, initJCFSelect],
        "body": removeMargin,
        ".main-header": [headerAnimationHandler, mainNav],
        ".language-switcher": langSwitcher,
        "#map": googleMap,
        ".load-action": loadAction,
        ".print": printArticle,
        ".ajax-filter": ajaxFilter,
        ".images-slider": imagesSlider,
        ".digits-slider": digitsSlider,
        ".featured-properties-slider": featuredPropertiesSlider,
        ".map-desktop": homeMap,
        "#form-location": ajaxMap,
        ".current-vacancies": anchorCareers,
        ".bg-load": deferredScript,
        ".cookie-popup": cookiePopup
    },
    runTests: false
});


// WEBPACK FOOTER //
// ./assets/js/global.js